module.exports = __webpack_public_path__ + "img/growcify-rufil-banner.6eb419c2.png";